import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../twc.refresh-layer-plugin.service';
import { LIFR_FLIGHT_RULES_PRODUCT_DATA } from './flight-rules-lifr.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class FlightRulesLifrPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(LIFR_FLIGHT_RULES_PRODUCT_DATA, {
    twcLayerTypes: ['web-tile']
  });
}
